/**
 *
 * Ripspot Memorial
 *
 */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import Input from 'components/Elements/Input';

import useCopyValue from 'utils/hooks/useCopyValue';

import {
  FacebookShareButton,
  EmailShareButton,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
  EmailIcon,
} from 'react-share';

const SocialShare = ({
  name,
  birthYear,
  deathYear,
  shareURL,
  isOnMemorialPage,
}) => {
  const {
    handleClick,
    textareaRef,
    copySuccess,
    supportsCopy,
  } = useCopyValue();
  return (
    <SocialShareWrapper isOnMemorialPage={isOnMemorialPage}>
      <ShareTitle>Share Now</ShareTitle>
      <CircleWrapper>
        <FacebookShareButton
          quote={`In celebration of ${name} (${birthYear} - ${deathYear}) we’d like to share a location that was very special to them. May they rest in peace.`}
          url={shareURL}
        >
          <FacebookIcon size={48} round={true} />
        </FacebookShareButton>
        <TwitterShareButton
          title={`In celebration of ${name} (${birthYear} - ${deathYear}) we’d like to share a location that was very special to them. May they rest in peace.`}
          via={`ripspot`}
          url={shareURL}
        >
          <TwitterIcon size={48} round={true} />
        </TwitterShareButton>
        <EmailShareButton
          subject={`In celebration of ${name} (${birthYear} - ${deathYear}).`}
          body={`In celebration of ${name} (${birthYear} - ${deathYear}) we’d like to share a location that was very special to them. May they rest in peace.`}
          url={shareURL}
        >
          <EmailIcon size={48} round={true} />
        </EmailShareButton>
      </CircleWrapper>
      <InputWrapper>
        <textarea ref={textareaRef} value={shareURL} />
        <Input
          style={{ flex: 1 }}
          placeholder={shareURL}
          value={shareURL}
          readOnly
        />
        {supportsCopy && (
          <button type="button" onClick={handleClick}>
            Copy
          </button>
        )}
      </InputWrapper>
    </SocialShareWrapper>
  );
};

SocialShare.propTypes = {};

export default SocialShare;

const CircleWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  padding-top: 5px;
  padding-bottom: 5px;
  margin-bottom: 10px;
  margin-top: 10px;
`;

const SocialShareWrapper = styled.div`
  text-align: center;
  ${({ isOnMemorialPage }) =>
    isOnMemorialPage &&
    css`
      max-width: 400px;
      width: 90%;
      margin: 0 auto;
      margin-top: 2em;
    `}
`;

const ShareTitle = styled.h3`
  font-family: 'Montserrat', sans-serif;
  font-size: 3em;
`;

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  border-radius: 2px;
  border: 1px solid #000;
  textarea {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }

  input {
    outline: none;
    border: none;
  }

  button {
    background-color: ${({ theme }) => theme.colors.Primary};
    color: white;
    font-size: 18px;
    padding: 10px 15px;
    border: none;
    cursor: pointer;
    transition: box-shadow 0.3s, background-color 0.3s;
    height: 3rem;
    &:hover {
      background-color: ${({ theme }) => theme.colors.Primary};
    }
  }
`;
